import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const EmailVerificationRedirect = () => {
  const location = useLocation();
  useEffect(() => {
    const redirectUrl = new URL(`${process.env.REACT_APP_BACKEND_URL}/verification/email/check_v3`);
    redirectUrl.search = location.search;
    window.location.href = redirectUrl;
  }, [location]);

  return (<div>Redirecting...</div>);
};

export default EmailVerificationRedirect;